import {Component, Input, OnInit} from '@angular/core';

import {SubtitlesService, ZonesSystemService} from "../../core";
import {SystemContainerView, SystemContainerViewWithId} from "../../models";

@Component({
    selector: 'zones-container',
    templateUrl: './zones-container.component.html',
    styleUrls: ['./zones-container.component.scss']
})
export class ZonesContainerComponent implements OnInit {
    @Input() container: SystemContainerViewWithId;
    @Input() containerName: string;
    @Input() fullWidth: boolean = false;
    details: SystemContainerView;
    showLabel: boolean = false;
    showZones: boolean = false;

    constructor(
        private subtitles: SubtitlesService,
        private zonesSystem: ZonesSystemService,
    ) {
    }

    ngOnInit() {
        if (!this.container && !this.containerName) { // tile container
            this.showLabel = false;
            this.showZones = true;
        } else if (!this.container && this.containerName) { // additionalInfo container
            this.details = {
                containerName: this.subtitle(2972),
                parameters: {}
            } as SystemContainerView;
            this.showLabel = true;
            this.showZones = this.setOpen();
        } else {
            this.details = this.container.data;
            this.showLabel = true;
            this.showZones = this.setOpen();
        }
    }

    subtitle(value: number): string {
        return this.subtitles.setSubtitle(value);
    }

    private noCommunication(): boolean {
        return this.details.parameters.signal === -3;
    }

    private setOpen() {
        if (this.fullWidth && this.noCommunication()) return false;
        if (!this.details) return;

        return this.details.expanded === undefined ? true : this.details.expanded;
    }

    toggleContainer() {
        if (this.fullWidth && this.noCommunication()) return;

        this.showZones = !this.showZones;
        if (this.container) {
            this.zonesSystem.setContainerExpand(this.container.containerId, this.showZones);
        }
    }
}
